import React from 'react';
import PropTypes from 'prop-types';

import StarRating from 'Components/ProductReviews/UserReviews/StarRating';

import 'Components/BundleCarousel/BundleCarouselUserReviewScore.scss';

const BundleCarouselUserReviewScore = ({ userReviewSummary }) => {
  if (!userReviewSummary) return false;

  const userReviewRatingScore = userReviewSummary.rating_score;
  const userReviewTotalRatings = userReviewSummary.total_ratings;

  if (!userReviewRatingScore || (userReviewRatingScore && userReviewRatingScore < 4)) {
    return false;
  }

  return (
    <section className="BundleCarouselUserReviewScore">
      <div className="BundleCarouselUserReviewScore__stars mr-2">
        <StarRating rating={userReviewRatingScore} />
      </div>
      <div className="BundleCarouselUserReviewScore__score mr-1">
        {userReviewRatingScore}
      </div>
      <div className="BundleCarouselUserReviewScore__ratings">
        ({userReviewTotalRatings})
      </div>
    </section>
  );
};

BundleCarouselUserReviewScore.propTypes = {
  userReviewSummary: PropTypes.shape({
    rating_score: PropTypes.number,
    total_ratings: PropTypes.number,
  }),
};

BundleCarouselUserReviewScore.defaultProps = {
  userReviewSummary: null,
};


export default BundleCarouselUserReviewScore;
